import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import Divider from "@mui/material/Divider";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { withSx } from "ui/atoms/Modal";
import Tabs from "ui/atoms/Tabs";
import { TriggerableDialog } from "ui/molecules/Dialog";
import { TabLayout } from "ui/widgets/StatefulTabs";
import GeneralInfo from "./GeneralInfo";
import Request from "./Request";
import Response from "./Response";
import SystemDecision from "./SystemDecision";
import { CurrentTransactionStateTab } from "./types";

const CurrentTransactionState = () => {
    const props = {
        sx: {
            height: 'calc(100vh - 358px)',
            display: 'grid'
        }
    };

    return (
        <TriggerableDialog
            TriggerComponent={({ onClick }) => (
                <LoadingButton
                    variant='outlined'
                    onClick={onClick}
                    endIcon={(
                        <VisibilityIcon />
                    )}
                >
                    View Transaction Details
                </LoadingButton>
            )}
            ModalProps={{
                titleSlot: 'Current Transaction State',
                DialogProps: withSx({
                    maxWidth: 'lg'
                })
            }}
        >
            <GeneralInfo />
            <Divider sx={{
                marginTop: 3,

            }} />
            <Tabs
                model={[
                    {
                        key: CurrentTransactionStateTab.Request,
                        label: 'Request',
                        component: (
                            <TabLayout
                                {...props}
                            >
                                <Request />
                            </TabLayout>
                        )
                    },
                    {
                        key: CurrentTransactionStateTab.Response,
                        label: 'Response',
                        component: (
                            <TabLayout
                                {...props}
                            >
                                <Response />
                            </TabLayout>
                        )
                    },
                    {
                        key: CurrentTransactionStateTab.SystemDecision,
                        label: 'System Decision',
                        component: (
                            <TabLayout
                                {...props}
                            >
                                <SystemDecision />
                            </TabLayout>
                        )
                    }
                ]}
                TabPanelProps={{
                    sx: {
                        p: 0
                    }
                }}
                TabListContainerProps={{
                    borderBottom: 1,
                    borderColor: 'divider'
                }}
                TabListProps={{
                    'aria-label': 'current transaction state',
                    variant: 'scrollable',
                    scrollButtons: 'auto'
                }}
            />
        </TriggerableDialog>
    );
};

export default memo(CurrentTransactionState);
